import { Button } from "react-bootstrap";
import { SelectButton, SelectInfoStyled } from "./styled";

interface ISelectAllInfo {
    totalItens: number,
    totalSelected: number,
    allSelected: boolean,
    checkAllType?:any,
    handleClearSelection: () => void,
    handleSelectAllMaterial: () => void
}

export const SelectAllInfo: React.FC<ISelectAllInfo> = (props) => {
    const {totalItens, totalSelected, allSelected, checkAllType, handleClearSelection, handleSelectAllMaterial} = props;
    return (
        <SelectInfoStyled>
            <>
                <span
                    style={{
                        color: "#606060",
                        fontSize: 14,
                    }}
                >
                   Todos os {totalSelected} materiais  {allSelected ? `estão selecionados.`: `${checkAllType && checkAllType !== 'Todos' ? checkAllType.toLowerCase() : ""} nesta página estão selecionados.`}
                   <SelectButton variant="link" onClick={allSelected ? handleClearSelection : handleSelectAllMaterial}>
                        {allSelected ? "Limpar seleção" : `Selecionar todos os materiais ${checkAllType && checkAllType !== 'Todos' ? checkAllType.toLowerCase() : ""} do sistema`}
                    </SelectButton>
                </span>
                
            </>
        </SelectInfoStyled>
    );
};
